import React from "react";
import { Flex } from "antd";
import { alignMenuItems } from "../../constants";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { FORMAT_ELEMENT_COMMAND } from "lexical";

const AlignMenu: React.FC = () => {
  const [editor] = useLexicalComposerContext();

  return (
    <Flex gap={16}>
      {alignMenuItems.map((option, index) => (
        <Flex
          key={index}
          onClick={() =>
            editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, option.payload)
          }
          style={{ height: 16 }}
        >
          {option.icon}
        </Flex>
      ))}
    </Flex>
  );
};

export default AlignMenu;
